import CropListingList from "../../slices/marketplace/crop_listing/CropListingList";
import CropListingDetails from "../../slices/marketplace/crop_listing/CropListingDetails";

const marketplaceReducer = {
    cropListingList: CropListingList,
    cropListingDetails: CropListingDetails,
};

export default marketplaceReducer;